module.exports = {
	"id": "FI",
	"name": "Finland",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006765,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.02706,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006765,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.033825,
			"32": null,
			"33": 0.01353,
			"34": 0.020295,
			"35": 0.006765,
			"36": 0.006765,
			"37": 0.01353,
			"38": 0.020295,
			"39": 0.02706,
			"40": 0.01353,
			"41": 0.01353,
			"42": 0.020295,
			"43": 0.060885,
			"44": 0.02706,
			"45": 0.04059,
			"46": 0.04059,
			"47": 0.060885,
			"48": 0.101475,
			"49": 1.09593,
			"50": 0.10824,
			"51": 0.35178,
			"52": 0.507375,
			"53": 24.022515,
			"54": 6.338805,
			"55": 0.06765,
			"56": 0.033825,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006765,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.006765,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.006765,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006765,
			"29": null,
			"30": 0.020295,
			"31": 0.02706,
			"32": 0.01353,
			"33": 0.01353,
			"34": 0.01353,
			"35": 0.020295,
			"36": 0.020295,
			"37": 0.020295,
			"38": 0.087945,
			"39": 0.02706,
			"40": 0.033825,
			"41": 0.033825,
			"42": 0.074415,
			"43": 0.087945,
			"44": 0.05412,
			"45": 0.62238,
			"46": 0.087945,
			"47": 0.56826,
			"48": 0.83886,
			"49": 14.12532,
			"50": 0.16236,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.01353
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.006765,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.04059,
			"37": 0.047355,
			"38": 0.02706,
			"39": 0.01353,
			"40": 0.710325,
			"41": 0.12177,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006765,
			"12.1": 0.10824
		},
		"safari": {
			"0": null,
			"4": 0.006765,
			"5": 0.033825,
			"6": 0.006765,
			"7": 0.02706,
			"8": 0.223245,
			"9": 0.290895,
			"10": 2.09715,
			"3.1": null,
			"3.2": null,
			"5.1": 0.09471,
			"6.1": 0.06765,
			"7.1": 0.020295,
			"9.1": 1.42065
		},
		"ios_saf": {
			"8": 0,
			"10": 6.08841295254,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.164075684013,
			"8.1-8.4": 0.303122873855,
			"9.0-9.2": 0.144609077435,
			"9.3": 2.20621541216
		},
		"android": {
			"3": 0,
			"4": 0.018894248062,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00236178100775,
			"4.1": 0.068154251938,
			"4.2-4.3": 0.170385629845,
			"4.4": 0.39070605814,
			"4.4.3-4.4.4": 0.394080031008
		},
		"ie": {
			"6": 0.0067779226361,
			"7": 0.0135558452722,
			"8": 0.108446762178,
			"9": 0.210115601719,
			"10": 0.162670143266,
			"11": 6.59491872493,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0165038644068,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000458440677966
		},
		"edge": {
			"12": 0.074415,
			"13": 0.588555,
			"14": 2.09715
		},
		"ie_mob": {
			"10": 0.404933239437,
			"11": 1.64865676056
		},
		"bb": {
			"7": 0.001617,
			"10": null
		},
		"samsung": {
			"0": 3.984288
		},
		"and_uc": {
			"0": 0.08085
		},
		"op_mini": {
			"0": 0.222353694915
		},
		"and_chr": {
			"0": 16.624773
		},
		"and_ff": {
			"0": 0.06468
		}
	},
	"total": 98.309442
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/FI.json
 ** module id = 518
 ** module chunks = 0
 **/